<template>
	<div id="plates">
		<menu-component></menu-component>
		<div id="screen-container" class="screen-container">
			<default-header></default-header>
			<div id="panel-container">
				<collapsible-panel :panel="view.parametersPanel" 
				:folded="view.parametersPanel.collapsed"
				v-if="view.parametersPanel.isVisible"
				@collapsed="onPlateParameterCollapsed"
				:class="{'collapsible-panel-fullscren': view.parametersPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							id="parametersGrid"
							:grid="view.parametersPanel.gridConfiguration"
						></grid-component>
						
						<div class="button-container">
							<div class="button-container-align-left">
								
								<div class="button-div">
									<button class="button plate-grid-button"
										v-if="!view.parametersPanel.exporting"
										@click="() => openImportModal()">
										<i class="fas fa-file-import"></i> {{$t('import')}} 
									</button>
									<button class="button plate-grid-button"
										v-if="!view.parametersPanel.exporting"
										@click="() => enterExportMode()">
											<i class="fas fa-file-export"></i> {{$t('export')}} 
									</button>
									<button class="button plate-grid-button"
										v-if="!view.parametersPanel.exporting"
										@click="enterExportPlateMode('parametersPanel')">
										<i class="fas fa-file-export"></i> {{$t('export_plate')}} 
									</button>
									<button class="button plate-grid-button"
										v-if="!view.parametersPanel.exporting"
										@click="() => openReplicationModal()">
											<i class="fa-solid fa-share-from-square"></i> {{$t('replicate_parameters')}} 
									</button>
								</div>
								
								<div class="export-mode-buttons">
									<button class="button plate-grid-button"
									v-if="view.parametersPanel.exporting"
									@click="() => exitExportMode()"
									:class="{'disabled': view.parametersPanel.exportModal.exportLoading}">
										<i class="fas fa-times"></i> {{$t('cancel_export')}} </button>
									<button class="button plate-grid-button"
									v-if="view.parametersPanel.exporting && !view.parametersPanel.isExportingPlates"
									@click="() => confirmExport()"
									:class="{'disabled': view.parametersPanel.exportModal.exportLoading}">
										<i class="fas fa-check"></i> {{$t('confirm_export')}} </button>
									<button class="button plate-grid-button"
									v-if="view.parametersPanel.isExportingPlates"
									@click="() => openModalExportPlates()"
									:class="{'disabled': view.parametersPanel.exportModal.exportLoading}">
										<i class="fas fa-check"></i> {{$t('Selecionar unidades')}} </button>
								</div>
							</div>

							<div class="button-container-align-right">
								<button v-if="showBatchOptimizer()" class="button gray-button" @click="getGeneratedExcellFromPython()">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('active_revenue_base')}}</span> 
								</button>
								
								<input type="file" @change="handleFileUpload" accept=".xlsx, .xls" ref="fileInput"/>
								
							   <button class="button gray-button" @click="submitFile('IMP_PARAMPRATFILIAL')">
							      <i class="fas fa-upload"></i> {{$t('send_file')}}
							   </button>
							   
								<button class="button gray-button" @click="exportToExcel(view.parametersPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.parametersPanel,'fullscreen')">
										<span v-show="!view.parametersPanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.parametersPanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :folded="view.combinationPanel.collapsed" 
				:panel="view.combinationPanel" v-if="view.combinationPanel.isVisible"
				@collapsed="(v) => sync(v, view.combinationPanel, 'collapsed')"
				:class="{'collapsible-panel-fullscren': view.combinationPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							id="attractivenessGrid"
							class="low-height-grid"
							:grid="view.combinationPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.combinationPanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.combinationPanel, ev)"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="button plate-grid-button" @click="addNewCombinationRow">
									<i class="fas fa-plus"></i> {{$t('new')}} 
								</button>
								<button class="button plate-grid-button" 
								@click="deleteCombination(view.combinationPanel)" > 
									<i class="fas fa-trash"></i> {{$t('delete')}} 
								</button>
								<button class="button plate-grid-button"
								v-show="view.combinationPanel.isAddingNewRow"
								@click="() => removeNewRow(view.combinationPanel)">
									<i class="fas fa-times"></i> {{$t('cancel')}} </button>
								<button class="button plate-grid-button" 
								@click="showExportModal('UNITY', 'COMBINACAOCARD')">
									{{$t('export_record')}}
								</button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.combinationPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.combinationPanel,'fullscreen')">
										<span v-show="!view.combinationPanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.combinationPanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				 <div>
				<collapsible-panel :folded="view.mainIngredientPanel.collapsed" :panel="view.mainIngredientPanel"
					v-if="view.mainIngredientPanel.isVisible"
					:class="{'collapsible-panel-fullscren': view.mainIngredientPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							class="low-height-grid"
							id="attractivenessGrid"
							:grid="view.mainIngredientPanel.gridConfiguration"
							@update:isAddingNewRow="(ev) => updateIsAddingNewRow(view.mainIngredientPanel, ev)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.mainIngredientPanel, ev)"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="button plate-grid-button" @click="addNewMainIngredientRow">
									<i class="fas fa-plus"></i> {{$t('new')}} 
								</button>
								<button class="button plate-grid-button" 
								@click="deleteMainIngredient(view.mainIngredientPanel)"
								v-show="view.mainIngredientPanel.hasCheckedRows &&
								!view.mainIngredientPanel.isAddingNewRow" > 
									<i class="fas fa-trash"></i> {{$t('delete')}} 
								</button>
								<button class="button plate-grid-button"
								v-show="view.mainIngredientPanel.isAddingNewRow"
								@click="() => removeNewRow(view.mainIngredientPanel)">
									<i class="fas fa-times"></i> {{$t('cancel')}} </button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.mainIngredientPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.mainIngredientPanel,'fullscreen')">
										<span v-show="!view.mainIngredientPanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.mainIngredientPanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :folded="view.typeProtein.collapsed" :panel="view.typeProtein"
					v-if="view.typeProtein.isVisible"
					:class="{'collapsible-panel-fullscren': view.typeProtein.fullscreen}">
					<div class="grid-container">
						<grid-component
							class="low-height-grid"
							id="attractivenessGrid"
							:grid="view.typeProtein.gridConfiguration"
							@update:isAddingNewRow="(ev) => updateIsAddingNewRow(view.typeProtein, ev)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.typeProtein, ev)"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="button plate-grid-button" @click="addNewProteinTypeRow">
									<i class="fas fa-plus"></i> {{$t('new')}} 
								</button>
								<button class="button plate-grid-button" 
								@click="deleteTypeProtein(view.typeProtein)"
								v-show="view.typeProtein.hasCheckedRows &&
								!view.typeProtein.isAddingNewRow" > 
									<i class="fas fa-trash"></i> {{$t('delete')}} 
								</button>
								<button class="button plate-grid-button"
								v-show="view.typeProtein.isAddingNewRow"
								@click="() => removeNewRow(view.typeProtein)">
									<i class="fas fa-times"></i> {{$t('cancel')}} </button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.typeProtein)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.typeProtein,'fullscreen')">
										<span v-show="!view.typeProtein.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.typeProtein.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :folded="view.attractivenessPanel.collapsed" :panel="view.attractivenessPanel"
				@collapsed="(v) => sync(v, view.attractivenessPanel, 'collapsed')"
				v-if="view.attractivenessPanel.isVisible"
				:class="{'collapsible-panel-fullscren': view.attractivenessPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							class="low-height-grid"
							id="attractivenessGrid"
							:grid="view.attractivenessPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.attractivenessPanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.attractivenessPanel, ev)"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="button plate-grid-button" @click="addNewAttractivness">
									<i class="fas fa-plus"></i> {{$t('new')}} 
								</button>
								<button class="button plate-grid-button" 
								v-show="!view.attractivenessPanel.isAddingNewRow &&
								!view.attractivenessPanel.hasCheckedRows"
								@click="addNewAttractivenessRow" >
									<i class="fas fa-file-import"></i> {{$t('import')}} </button> 
								<button class="button plate-grid-button" 
								@click="deleteAttractivness(view.attractivenessPanel)"
								v-show="view.attractivenessPanel.hasCheckedRows &&
								!view.attractivenessPanel.isAddingNewRow" > 
									<i class="fas fa-trash"></i> {{$t('delete')}} 
								</button>
								<button class="button plate-grid-button"
								v-show="view.attractivenessPanel.isAddingNewRow"
								@click="() => removeNewRow(view.attractivenessPanel)">
									<i class="fas fa-times"></i> {{$t('cancel')}} </button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.attractivenessPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.attractivenessPanel,'fullscreen')">
										<span v-show="!view.attractivenessPanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.attractivenessPanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :folded="view.prapartionMethodPanel.collapsed" :panel="view.prapartionMethodPanel"
				v-if="view.prapartionMethodPanel.isVisible"
				:class="{'collapsible-panel-fullscren': view.prapartionMethodPanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							id="attractivenessGrid"
							class="low-height-grid"
							:grid="view.prapartionMethodPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.prapartionMethodPanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.prapartionMethodPanel, ev)"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="button plate-grid-button" @click="addNewPreparationMethodRow">
									<i class="fas fa-plus"></i> {{$t('new')}} 
								</button>
								<button class="button plate-grid-button" 
								@click="deletePreparationMethod(view.prapartionMethodPanel)"
								v-show="view.prapartionMethodPanel.hasCheckedRows && 
								!view.prapartionMethodPanel.isAddingNewRow" > 
									<i class="fas fa-trash"></i> {{$t('delete')}} 
								</button>
								<button class="button plate-grid-button"
								v-show="view.prapartionMethodPanel.isAddingNewRow"
								@click="() => removeNewRow(view.prapartionMethodPanel)">
									<i class="fas fa-times"></i> {{$t('cancel')}} </button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.prapartionMethodPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.prapartionMethodPanel,'fullscreen')">
										<span v-show="!view.prapartionMethodPanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.prapartionMethodPanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :folded="view.cutTypePanel.collapsed" :panel="view.cutTypePanel"
				v-if="view.cutTypePanel.isVisible"
				:class="{'collapsible-panel-fullscren': view.cutTypePanel.fullscreen}">
					<div class="grid-container">
						<grid-component
							id="attractivenessGrid"
							class="low-height-grid"
							:grid="view.cutTypePanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.cutTypePanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.cutTypePanel, ev)"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="button plate-grid-button" @click="addNewCutTypeRow">
									<i class="fas fa-plus"></i> {{$t('new')}} 
								</button>
								<button class="button plate-grid-button" 
								@click="deleteCutType(view.cutTypePanel)"
								v-show="view.cutTypePanel.hasCheckedRows &&
								!view.cutTypePanel.isAddingNewRow" > 
									<i class="fas fa-trash"></i> {{$t('delete')}} 
								</button>
								<button class="button plate-grid-button"
								v-show="view.cutTypePanel.isAddingNewRow"
								@click="() => removeNewRow(view.cutTypePanel)">
									<i class="fas fa-times"></i> {{$t('cancel')}} </button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.cutTypePanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.cutTypePanel,'fullscreen')">
										<span v-show="!view.cutTypePanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.cutTypePanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
				<collapsible-panel :folded="view.consumptionHistoryPanel.collapsed" :panel="view.consumptionHistoryPanel"
					@collapsed="(v) => sync(v, view.consumptionHistoryPanel, 'collapsed')"
					v-if="view.consumptionHistoryPanel.isVisible"
					class="consumption-history-panel"
					:class="{
						'collapsible-panel-fullscren': view.consumptionHistoryPanel.fullscreen,
						'is-saving-interval': view.consumptionHistoryPanel.isSavingInterval
					}">

					<div class="consumption-history-interval-container">
						<div class="consumption-history-main-line">
							<span>{{$t('consider_range_of')}}</span>

							<input
							:value="view.consumptionHistoryPanel.interval"
							@change="updateConsumptionHistoryInterval"
							type="number"
							class="consumption-history-interval-input"
							min="1"
							step="1"
							required
							/>

							<span>{{ consumptionHistoryMonthsIntervalInfo }}</span>

							<div class="consumption-history-type-container">
							<label>
								<input
								type="radio"
								value="S"
								v-model="view.consumptionHistoryPanel.historyType"
								@change="onHistoryTypeChange('S')"
								/>
								<span>{{$t('registered')}}</span>
							</label>

							<label>
								<input
								type="radio"
								value="N"
								v-model="view.consumptionHistoryPanel.historyType"
								@change="onHistoryTypeChange('N')"
								/>
								<span>{{$t('not_registered')}}</span>
							</label>
							</div>
						</div>

						<div class="error-message">
							{{$t('enter_an_integer_greater_than_1')}}
						</div>
					</div>
				
					<div class="grid-container">
						<grid-component
							id="attractivenessGrid"
							:class="{
								'low-height-grid': !view.consumptionHistoryPanel.fullscreen,
								'history-low-height-grid': view.consumptionHistoryPanel.fullscreen,
							}"
							:grid="view.consumptionHistoryPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.consumptionHistoryPanel, $event)"
							@update:hasCheckedRows="(ev) => onConsumptionHistoryCheckedRowsChange(ev)"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="button plate-grid-button" 
								v-show="!view.consumptionHistoryPanel.exporting"
								@click="addNewConsumptionHistoryRow">
									<i class="fas fa-plus"></i> {{$t('new')}} 
								</button>
								<button class="button plate-grid-button" 
								v-show="!view.consumptionHistoryPanel.isAddingNewRow &&
								!view.consumptionHistoryPanel.exporting && view.consumptionHistoryPanel.historyType != 'N'"
								@click="enterExportPlateMode('consumptionHistoryPanel')">
									<i class="fas fa-plus"></i> {{$t('export_history_consumption')}} 
								</button>
								<button class="button plate-grid-button" 
								@click="deleteConsumptionHistory(view.consumptionHistoryPanel)"
								v-show="view.consumptionHistoryPanel.hasCheckedRows && 
								view.consumptionHistoryPanel.isRowDeletable &&
								!view.consumptionHistoryPanel.exporting &&
								!view.consumptionHistoryPanel.isAddingNewRow" > 
									<i class="fas fa-trash"></i> {{$t('delete')}} 
								</button>
								<button class="button plate-grid-button"
								v-show="view.consumptionHistoryPanel.isAddingNewRow"
								@click="() => removeNewRow(view.consumptionHistoryPanel)">
									<i class="fas fa-times"></i> {{$t('cancel')}} </button>
								<div class="export-mode-buttons">
									<button class="button plate-grid-button"
									v-if="view.consumptionHistoryPanel.exporting"
									@click="() => exitExportModeHistory()"
									:class="{'disabled': view.consumptionHistoryPanel.exportModal.exportLoading}">
										<i class="fas fa-times"></i> {{$t('cancel_export')}} 
									</button>
									<button class="button plate-grid-button"
									v-if="view.consumptionHistoryPanel.exporting"
									@click="() => openModalHistoryConsumption()"
									:class="{'disabled': view.consumptionHistoryPanel.exportModal.exportLoading}">
										<i class="fas fa-check"></i> {{$t('Selecionar unidades')}} 
									</button>
								</div>
							</div>
							<div class="button-container-align-right">
								<input type="file" @change="handleFileUpload" accept=".xlsx, .xls" ref="fileInput"/>
								
								<button class="button gray-button" @click="submitFile('IMP_HISTCONSUMOPRATO')">
									 <i class="fas fa-upload"></i> {{$t('send_file')}}
								</button>
								<button class="button gray-button" @click="exportToExcel(view.consumptionHistoryPanel)">
									<i class="fas fa-file-excel"></i>
									<span> {{$t('export')}} </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.consumptionHistoryPanel,'fullscreen')">
										<span v-show="!view.consumptionHistoryPanel.fullscreen">
											<i class="fas fa-expand-arrows-alt"></i>
										</span>
										<span v-show="view.consumptionHistoryPanel.fullscreen">
											<i class="fas fa-compress-arrows-alt"></i>
										</span>
								</button>
							</div>
						</div>
					</div>
 				</collapsible-panel>
 				<!-- painel de regras de restrição de repetição retirado.
				<collapsible-panel :folded="view.restrictionRulesPanel.collapsed" :panel="view.restrictionRulesPanel"
					:collapsed.sync="view.restrictionRulesPanel.collapsed"
					@collapsed="onRestrictionRulesPanelCollapsed"
					v-if="view.restrictionRulesPanel.isVisible"
					class="restriction-rules-panel"
					:class="{'collapsible-panel-fullscren': view.restrictionRulesPanel.fullscreen}">
					<div class="collapsible-panel-content-wrapper">
						<div class="top-section">
							<v-select
								class="restriction-rule-select" 
								:options="view.restrictionRulesPanel.rules"
								:getOptionLabel="o => `${o.NRREGRARESTREPET} | ${o.NMREGRARESTREPET}`"
								@input="onRestrictionRuleSelected"
								:clearable="false" 
								v-model="view.restrictionRulesPanel.selectedRule"/>
							<button class="button plate-grid-button" @click="showAddRestrictionRulePopUp()">
									{{$t('add_rule')}}</button>
								<button class="button plate-grid-button" 
								@click="showEditRestrictionRulePopUp()"> 
									{{$t('edit_rule')}} </button>
								<button class="button plate-grid-button" 
								@click="removeRestrictionRule()">
									{{$t('delete_rule')}}</button>
								<button class="button plate-grid-button" 
									@click="showExportModal('UNITY', 'REGRARESTREPET')">
									{{$t('export_record')}}
								</button>
						</div>
						<div class="bottom-section bottom-content-grid"
						:class="{'disabled': !isRestrictionRulesInteractable}">
							<div class="plate-type-grid-container">
								<span>{{$t('dish_type')}} </span>
								<grid-component 
								:grid="view.restrictionRulesPanel.plateType.gridConfiguration"
								:hasCheckedRows.sync="view.restrictionRulesPanel.plateType.hasCheckedRows"
								class="low-height-grid"
								:isAddingNewRow.sync="view.restrictionRulesPanel.plateType.isAddingNewRow"/>
								<div class="button-container inline">
									<button class="button plate-grid-button" @click="addNewPlateTypeRestrictionRuleRow">
										<i class="fas fa-plus"></i> {{$t('new')}} 
									</button>
									<button class="button plate-grid-button margin-left-5" 
									@click="removePlateTypeRestrictionRule()"
									v-show="view.restrictionRulesPanel.plateType.hasCheckedRows &&
									!view.restrictionRulesPanel.plateType.isAddingNewRow" > 
										<i class="fas fa-trash"></i> {{$t('delete')}} 
									</button>
									<button class="button plate-grid-button margin-left-5"
									v-show="view.restrictionRulesPanel.plateType.isAddingNewRow"
									@click="() => removeNewRow(view.restrictionRulesPanel.plateType)">
										<i class="fas fa-times"></i> {{$t('cancel')}} </button>
								</div>
							</div>
							<div class="ingredient-grid-container">
								<span>{{$t('ingredients')}}</span>
								<grid-component 
								:grid="view.restrictionRulesPanel.ingredient.gridConfiguration"
								:hasCheckedRows.sync="view.restrictionRulesPanel.ingredient.hasCheckedRows"
								class="low-height-grid"
								:isAddingNewRow.sync="view.restrictionRulesPanel.ingredient.isAddingNewRow"/>
								<div class="button-container">
									<div class="button-container-align-left">
										<button class="button plate-grid-button" @click="addNewIngredientRestrictionRuleRow">
											<i class="fas fa-plus"></i> {{$t('new')}} 
										</button>
										<button class="button plate-grid-button margin-left-5" 
										@click="removeIngredientRestrictionRule()"
										v-show="view.restrictionRulesPanel.ingredient.hasCheckedRows &&
										!view.restrictionRulesPanel.ingredient.isAddingNewRow" > 
											<i class="fas fa-trash"></i> {{$t('delete')}} 
										</button>
										<button class="button plate-grid-button margin-left-5"
										v-show="view.restrictionRulesPanel.ingredient.isAddingNewRow"
										@click="() => removeNewRow(view.restrictionRulesPanel.ingredient)">
											<i class="fas fa-times"></i> {{$t('cancel')}} </button>
									</div>
									<div class="button-container-align-right">
										<button class="button gray-button" @click="exportToExcelRestriction(view.restrictionRulesPanel)">
											<i class="fas fa-file-excel"></i>
											<span> {{$t('export')}} </span> 
										</button>
										<button class="button gray-button" 
										@click="invertValue(view.restrictionRulesPanel,'fullscreen')">
												<span v-show="!view.restrictionRulesPanel.fullscreen">
													<i class="fas fa-expand-arrows-alt"></i>
												</span>
												<span v-show="view.restrictionRulesPanel.fullscreen">
													<i class="fas fa-compress-arrows-alt"></i>
												</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</collapsible-panel>
				-->
				 </div>
			</div>
		</div>
		<modal name="plates-recipe-modal" @opened="view.recipeModal.onOpenModal">
			<grid-component
				class="recipe-grid"
				id="recipeGrid"
				:grid="view.recipeModal.gridConfiguration"
			></grid-component>
		</modal>
		<modal name="import-modal" @opened="view.parametersPanel.importModal.onOpenModal" :height="'auto'" :width="'90%'"
			:clickToClose="!view.parametersPanel.importModal.importLoading">
			<div class="import-modal">
				<h3 class="import-modal-title"> {{$t('import_plate_parameters')}} </h3>
				<grid-component
					class="import-modal-grid"
					id="importModalGrid"
					:grid="view.parametersPanel.importModal.gridConfiguration"
				></grid-component>

				<div class='button-div'>
					<button style="	line-height: .9rem" class="button outline plate-grid-button" @click="() => $modal.hide('import-modal')"
						:class="{'disabled': view.parametersPanel.importModal.importLoading}">
						<i class="fas fa-times"></i> {{$t('cancel')}} 
					</button>
					<button style="	line-height: .9rem" class="button plate-grid-button" @click="importParameters" 
						:class="{'disabled': view.parametersPanel.importModal.importLoading}">
						<i class="fas fa-file-import"></i> {{$t('import')}} 
					</button>
				</div>
			</div>
		</modal>
		<modal name="export-modal-fields" :height="'auto'" :clickToClose="false">
			<div class="export-modal-container">
				<h3> {{$t('select_fields_to_export_dish_parameters')}} </h3>
					<div class="export-modal-check-container">
						<div v-for="exportItem in view.parametersPanel.exportModal.exportFrom" 
						:key="exportItem.fieldName"
						class="export-modal-option"
						:class="{ selected: exportItem.selected}"
						@click="() => exportItem.selected = !exportItem.selected">
							<span class="export-modal-options-checkbox-container"> 
								<i class="far fa-square checkbox-unselected"></i> 
								<i class="far fa-check-square checkbox-selected"></i> 
							</span>
							<span class="export-modal-option-label">
								{{ exportItem.label}}:
							</span>
							<span class="export-modal-option-value">
								{{ exportItem.value}}
							</span>
						</div>
					</div>
				<button class="button plate-grid-button" @click="cancelExportInModal"> 
					<i class="fas fa-times"></i> {{$t('cancel')}} 
				</button>
				<button class="button plate-grid-button" @click="closeExportModal"> 
					<i class="fas fa-check"></i> {{$t('confirm')}} 
				</button>
			</div>
		</modal>
		<modal name="export-plates-modal-fields" :height="'auto'" :clickToClose="false">
			<div class="export-modal-container">
				<h3> {{$t('select_fields_to_export_dish_parameters')}} </h3>
				<div class="export-plate-modal-check-container">
					<div v-for="exportItem in view.parametersPanel.exportPlates.exportModal.exportFrom" 
							 :key="exportItem.fieldName"
							 class="export-modal-option"
							 :class="{ selected: exportItem.selected }"
							 @click="() => exportItem.selected = !exportItem.selected">
						<span class="export-modal-options-checkbox-container"> 
							<i class="far fa-square checkbox-unselected"></i> 
							<i class="far fa-check-square checkbox-selected"></i> 
						</span>
						<span class="export-modal-option-label">
							{{ exportItem.label }}
						</span>
					</div>
				</div>
				<div class="mode-switch">
					<div v-if="view.parametersPanel.exportPlates.showAdd" 
							 @click="switchMode('ACRESCENTAR')" 
							 class="mode-switch-option"
							 :class="{active: view.parametersPanel.exportPlates.exportPlatesMode === 'ACRESCENTAR'}"> 
						{{$t('add')}} 
					</div>
					<div v-if="view.parametersPanel.exportPlates.showOverlap" 
							 @click="switchMode('SOBREPOR')" 
							 class="mode-switch-option"
							 :class="{active: view.parametersPanel.exportPlates.exportPlatesMode === 'SOBREPOR'}"> 
						{{$t('overlap')}} 
					</div>
				</div>
				<div class="select-container">
					<label for="unity">{{$t('unit')}}:</label>
					<div class='inputs-div'>
						<v-select
							name="unity"
							class="restrinctions-select-autocomplete"
							multiple
							:close-on-select="false"
							:reduce="option => option.CDFILIAL"
							:options="view.parametersPanel.exportPlates.units.options"
							:getOptionLabel="o => `${o.CDFILIAL} | ${o.NMFILIAL}`"
							v-model="view.parametersPanel.exportPlates.units.selectedUnits"
							:clearable="true" 
							:disabled="view.parametersPanel.exportPlates.units.allSelected"
						/>
						<div class="input-container">
							<input 
								class="allCheck"
								type="checkbox"
								id="allCheck"
								name="allCheck"
								v-model="view.parametersPanel.exportPlates.units.allSelected"
							/>
							<label for='allCheck'>{{$t('all_f')}}</label>
						</div>
					</div>
				</div>
				<div class='button-div'>
					<button class="button plate-grid-button" @click="cancelExportPlatesInModal"> 
						<i class="fas fa-times"></i> {{$t('cancel')}} 
					</button>
					<button class="button plate-grid-button" @click="confirmExport"> 
						<i class="fas fa-check"></i> {{$t('confirm')}} 
					</button>
				</div>
			</div>
		</modal>
			<filter-action-modal
				name="replicate-params-modal"
				@opened="replicateModal.onOpenModal"
				:clickToClose="!replicateModal.replicateLoading && !replicateModal.prepareLoading"
				:width="'60%'"
				:title="$t('replicate_parameters_title')"
				:filterLabel="`${$t('replicate_parameters_input_label')}:`"
				:filterInfoTitle="$t('rep_param_search_tutorial')"
				:filterPlaceholder="$t('rep_param_input_placeholder')"
				:filterValue="replicateModal.filterText"
				:filterButtonLabel="$t('searchOoo')"
				:filterButtonDisabled="replicateModal.replicateLoading || replicateModal.prepareLoading"
				:cancelLabel="$t('cancel')"
				:confirmLabel="$t('apply')"
				:cancelDisabled="replicateModal.replicateLoading || replicateModal.prepareLoading"
				:confirmDisabled="replicateModal.replicateLoading || replicateModal.prepareLoading"
				:overlayLoading="replicateModal.prepareLoading"
				:overlayLoadingLabel="$t('loadingOoo')"
				:selectedCount="replicateModal.selectedCount"
				:grid="replicateModal.gridConfiguration"
				gridId="replicateParamsGrid"
				gridClass="replicate-modal-grid"
				@update:filterValue="(value) => replicateModal.filterText = value"
				@search="findDishesByFilterInput"
				@cancel="closeReplicationModal"
				@confirm="applyReplicationData"
			></filter-action-modal>
		<modal name="replicate-modal-fields" :height="'auto'" :width="'80%'" :clickToClose="false">
			<div class="export-modal-container replicate-modal-container">
				<h3> {{$t('select_fields_to_export_dish_parameters')}} </h3>
				
				<div class="export-modal-check-container replicate-modal-fields-container">
					<div v-for="replicateItem in replicateModal.replicateForm" 
						:key="replicateItem.fieldName"
						class="replicate-modal-option"
						:class="{ selected: replicateItem.selected}"
					>

						<div class="replicate-modal-option"
							@click="() => replicateItem.selected = !replicateItem.selected"
						>
							<span 
								class="export-modal-options-checkbox-container" 
							>
								<i class="far fa-square checkbox-unselected"></i>
								<i class="far fa-check-square checkbox-selected"></i>
							</span>

							<span 
								class="replicate-modal-option-label" 
							>
								{{ replicateItem.label}}:
							</span>
						</div>
						<v-select
							class="replicate-modal-option-input"
							:clearable="true"
							:disabled="!replicateItem.selected"
							:options="replicateItem.model"
							v-model="replicateItem.value"
							:reduce="option => option.value"
						/>
					</div>
				</div>

				<div class="select-container">
					<label for="unity">{{$t('unit')}}:</label>

					<div class='inputs-div'>
						<v-select
							name="unity"
							class="restrinctions-select-autocomplete"
							multiple
							:close-on-select="false"
							:reduce="option => option.CDFILIAL"
							:options="replicateModal.units.options"
							:getOptionLabel="o => `${o.CDFILIAL} | ${o.NMFILIAL}`"
							v-model="replicateModal.units.selectedUnits"
							:clearable="true" 
							:disabled="replicateModal.units.allSelected"
						/>
						<div class="input-container">
							<input 
								class="allCheck"
								type="checkbox"
								id="allCheck"
								name="allCheck"
							v-model="replicateModal.units.allSelected"
						/>
							<label for='allCheck'>{{$t('all_f')}}</label>
						</div>
					</div>
				</div>

				<div class='button-div' style="justify-content: space-between">
					<button style="	line-height: .9rem" class="button outline plate-grid-button" @click="cancelReplication"> 
						<i class="fas fa-times"></i> {{$t('cancel')}} 
					</button>
					<button style="	line-height: .9rem" class="button plate-grid-button" @click="confirmReplication"> 
						<i class="fas fa-check"></i> {{$t('confirm')}} 
					</button>
				</div>
			</div>
		</modal>
		<modal
			name="replicate-modal-errors"
			:height="'auto'"
			:width="'40%'"
			:clickToClose="false"
		>
			<div class="export-modal-container replicate-modal-container">
			<h3 v-if="!replicateModal.replicateLoading">
				{{ $t('replication_errors_title') }}
			</h3>

			<img 
				v-if="replicateModal.replicateLoading"
				style="width: 100%"
				:src="replicateModal.loadingGif" 
			/>
			
			<!-- aqui entra a lista de erros -->
			<div v-else class="errors-container">
				<p
				v-for="(error, idx) in replicateModal.errors"
				:key="error.CDFILIAL + '-' + idx"
				class="error-item"
				>
				Unidade: {{ error.CDFILIAL }} – {{ error.NMFILIAL }}
				</p>
				<!-- opcionalmente um fallback se não houver erros -->
				<p v-if="!replicateModal.errors.length">
				{{ $t('no_errors_to_display') }}
				</p>
			</div>

			<div v-if="!replicateModal.replicateLoading" class="button-div" style="justify-content: center">

				<button
					class="button"
					style="width: 10dvw;"
					@click="confirmErrors"
				>
					{{ $t('ok') }}
				</button>
			</div>
			</div>
		</modal>
		<modal 
			name="combination-form-modal" 
			:height="'auto'" 
			:clickToClose="false"
			:classes="'v-modal-overflow-visible'"
			:scrollable="true"
		>
			<combination-form :modal="$modal" @combinationSaved="afterCombinationSaved"/>
		</modal>
		<modal 
			name="Attractiveness-form-modal" 
			:height="'auto'" 
			:clickToClose="false"
			:classes="'v-modal-overflow-visible'"
			:scrollable="true">
			<Attractiveness-form :modal="$modal" @AttractivenessSaved="afterAttractivenessSaved"/>
		</modal>
		<modal name="restrictionRuleModal" :height="180">
			<div class="restriction-rule-form-root"> 
				<h3 class="title"> {{restrictionRulesModalTitle}} </h3>
				<div class="field text-field">
					<label>{{$t('name')}}:</label>
					<input type="text" v-model="view.restrictionModalData.name"/>
				</div>
				<button class="button save-restriction-rule-button" @click="saveRestrictionRule"> {{$t('save')}} </button>
			</div>
		</modal>
		<modal
			name="export-form-modal" 
			:height="'auto'" 
			:clickToClose="false"
		>
			<export-form
				:modal="$modal"
				:name="$t('export_record')"  
				:modalStyle="view.exportDataModal._style"
				:showLoad="view.exportDataModal._showLoad"
				:showAdd="view.exportDataModal._showAdd"
				@saveExport="saveExport"
			/>
		</modal>
		<div v-if="isLoadingSubmit" class="loading-overlay">
			<div class="spinner"></div>
			<p>{{$t('loading')}}</p>
		</div>		
	</div>
</template>

<script>
/**
 * Main screen controller
 */
import PlatesController from "../controllers/PlatesController";
               
/**
 * Our components
 */
import MenuComponent from '@/components/src/MenuComponent'
import DefaultHeader from '@/components/src/DefaultHeaderComponent'
import CollapsiblePanel from '@/components/src/CollapsiblePanelComponent'
import Grid from "@/components/src/GridComponent";
import vSelect from "vue-select";
import eventModule from '@/application/libs/eventModule';
import permissionManager from "@/application/libs/permissionManager"
import CombinationForm from '@/components/src/CombinationForm'
import AttractivenessForm from '@/components/src/AttractivenessForm'
import PlatesProvider from '../../application/providers/PlatesProvider';
import ExcelBuilder from  '@/application/libs/excelBuilder'
import ExportForm from '@/components/src/ExportForm'
import FilterActionModal from '@/components/src/modals/FilterActionModal'

import RestrictionProvider from '@/application/providers/RestrictionsProvider';

import Util from "@/application/libs/util"
import moment from "moment"
import { t } from 'i18next';
// import ProdENV from '../../../config/prod.env.js';
import * as XLSX from 'xlsx';

export default {
	name: "Plates",
	components:{
		'menu-component':MenuComponent,
		'default-header':DefaultHeader,
		'collapsible-panel':CollapsiblePanel,
		'grid-component': Grid,
		'combination-form': CombinationForm,
		'Attractiveness-form': AttractivenessForm,
		'v-select': vSelect,
		'export-form': ExportForm,
		'filter-action-modal': FilterActionModal
	},
	data() {
		return {
			view: {
				title: t('plates'),
				exportDataModal: {
					_showLoad: true
				},
				parametersPanel:{
					title: t('plate_parameters'),
					name:"parametersPanel",
					label:{
						title:"Legenda",
						content:"Teste"
					},
					gridConfiguration : PlatesController.parametersGridConfiguration,
					editTimeout: {
						id: null
					},
					changedRows: [],
					collapsed: false,
					fullscreen: false,
					info: t('info_plate_parameters')+`\n`+t('info_2_plate_parameters') ,
					importModal: {
						gridConfiguration : PlatesController.importPlatesGridConfiguration,
						onOpenModal: () => {/* fetch similar plate data */},
						importLoading: false
					},
					isExportingPlates: false,
					exporting: false,
					exportPlates: {
						exporting: false,
						showAdd: true,
						showOverlap: true,
						exportPlatesMode: 'ACRESCENTAR',
						units: {
							options: [],
							selectedUnits: [],
							allSelected: false
						},
						exportModal: {
							exportFrom: {},
							CDFILIAL: null,
							exportLoading: false
						}
					},
					exportModal: {
						exportFrom: {},
						CDFILIAL: null,
						exportLoading: false
					},
					isVisible: true,
					replicateModal: {
						gridConfiguration : PlatesController.replicateParametersGridConfiguration,
						onOpenModal: () => {/* fetch similar plate data */},
						replicateLoading: false,
						prepareLoading: false,
						selectedCount: 0,
						filterText: "",
						replicateForm: {},
						units: {
							options: [],
							selectedUnits: [],
							allSelected: false
						},
						prePreparationOptions: [
							{ value: "S", label: "Sim" },
							{ value: "N", label: "Não" },
						],
						attractivenesOptions: [],
						mainIngredientsOptions: [],
						proteinTypeOptions: [],
						preparationMethodOptions: [],
						cutTypeOptions: [],
						complexityOptions: [
							{ value: "BAIXA", label: "Baixa" },
							{ value: "MEDIA", label: "Média" },
							{ value: "ALTA", label: "Alta" },
						],
						colorOptions: [
							// { value: null, label: String.fromCharCode(0x00A0) },
							{ value: "NA", label: "NA" },
							{ value: "VERMELHO", label: "VERMELHO" },
							{ value: "AMARELO", label: "AMARELO" },
							{ value: "BRANCO", label: "BRANCO" },
							{ value: "VERDE", label: "VERDE" },
							{ value: "ROXO", label: "ROXO" },
							{ value: "BEGE", label: "BEGE" },
							{ value: "COLORIDA(O)", label: "COLORIDA(O)" },
							{ value: "MARROM", label: "MARROM" },
							{ value: "LARANJA", label: "LARANJA" },
							{ value: "DOURADO", label: "DOURADO" },
							{ value: "ROSA", label: "ROSA" },
							{ value: "CASTANHO CLARO", label: "CASTANHO CLARO" },
							{ value: "PRETO", label: "PRETO" },
							{ value: "VERDE CLARO", label: "VERDE CLARO" },
							{ value: "ROSA CLARO", label: "ROSA CLARO" },
							{ value: "CARAMELO", label: "CARAMELO" },
							{ value: "AMARELO CLARO", label: "AMARELO CLARO" },
							{ value: "VERDE ESCURO", label: "VERDE ESCURO" },
							{ value: "CORAL", label: "CORAL" },
							{ value: "SALMAO", label: "SALMAO" },
							{ value: "AMARELO ESCURO", label: "AMARELO ESCURO" },
							{ value: "COBRE", label: "COBRE" },
							{ value: "VERMELHO ESCURO", label: "VERMELHO ESCURO" },
							{ value: "VERMELHO ENEGRECIDO", label: "VERMELHO ENEGRECIDO" },
							{ value: "ROSA ESCURO", label: "ROSA ESCURO" },
							{ value: "FERRUGEM", label: "FERRUGEM" },
							{ value: "LILAS", label: "LILAS" },
							{ value: "AZUL", label: "AZUL" },
							{ value: "PARDO", label: "PARDO" },
						],
						errors: [],
						loadingGif: require("../../../static/otimizador2.gif"),
					},
					
				},
				attractivenessPanel:{
					title: t('attractiveness'),
					name:"attractivenessPanel",
					gridConfiguration : PlatesController.attractivenessGridConfiguration,
					collapsed: true,
					fullscreen: false,
					hasCheckedRows: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_attractiveness') +`\n` + t('info_2_attractiveness') +`\n\n` + t('info_3_attractiveness') + `\n` + t('info_4_attractiveness')
				},
				prapartionMethodPanel:{
					title: t('method_of_preparation'),
					name:"prapartionMethodPanel",
					gridConfiguration : PlatesController.prapartionMethodGridConfiguration,
					collapsed: true,
					fullscreen: false,
					hasCheckedRows: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_method_of_preparation') +`\n`+ t('info_2_method_of_preparation')
				},
				cutTypePanel:{
					title: t('type_of_cut'),
					name:"cutTypePanel",
					gridConfiguration : PlatesController.cutTypeGridConfiguration,
					collapsed: true,
					fullscreen: false,
					hasCheckedRows: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_type_of_cut') + `\n` + t('info_2_type_of_cut')
				},
				typeProtein:{
					title: t('type_protein'),
					name:"typeProtein",
					gridConfiguration : PlatesController.typeProteinGridConfiguration,
					collapsed: true,
					fullscreen: false,
					hasCheckedRows: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_type_protein')
				},
				mainIngredientPanel:{
					title: t('main_ingredient'),
					name:"mainIngredientPanel",
					gridConfiguration : PlatesController.mainIngredientGridConfiguration,
					collapsed: true,
					fullscreen: false,
					hasCheckedRows: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_main_ingredient')
				},
				combinationPanel:{
					title: t('combination'),
					name:"combinationPanel",
					gridConfiguration : PlatesController.combinationGridConfiguration,
					collapsed: true,
					fullscreen: false,
					hasCheckedRows: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_combination')
				},
				consumptionHistoryPanel:{
					title: t('consumption_percentage_history'),
					name:"consumptionHistoryPanel",
					gridConfiguration : PlatesController.consumptionHistoryGridConfiguration,
					collapsed: true,
					fullscreen: false,
					hasCheckedRows: false,
					isAddingNewRow: false,
					isRowDeletable: true,
					isVisible: true,
					interval: null,
					exporting: false,
					historyType: 'S',
					exportModal: {
						exportFrom: {},
						CDFILIAL: null,
						exportLoading: false
					},
					isSavingInterval: false,
					info: t('info_consumption_percentage_history')
				},
				restrictionRulesPanel: {
					title: t('ingredient_repetition_restriction'),
					name:"restrictionRulesPanel",
					collapsed: true,
					fullscreen: false,
					isVisible: true,
					selectedRule: null,
					rules: [],
					info: t('info_ingredient_repetition_restriction'),
					plateType: {
						isAddingNewRow: false,
						gridConfiguration: PlatesController.restrictionRulesPlateTypeGridConfig,
						hasCheckedRows: false
					},
					ingredient: {
						isAddingNewRow: false,
						gridConfiguration: PlatesController.restrictionRulesIngredientGridConfig,
						hasCheckedRows: false
					}
				},
				restrictionModalData: {
					name: "",
					mode: "add"
				},
				recipeModal:{
					gridConfiguration:PlatesController.plateRecipeGrid,
					onOpenModal:()=>{
						let recipeGrid = this.view.recipeModal.gridConfiguration;
						recipeGrid.setRowData(recipeGrid.__data);
						delete recipeGrid.__data;
					}
				},
			},
			filteredData: {

			},
			file: null,
			processedData: [],
			isLoadingSubmit: false,
			replicateModal: {
				onOpenModal: () => {},
				replicateLoading: false,
				prepareLoading: false,
				selectedCount: 0,
				filterText: '',
				gridConfiguration: null,
				replicateForm: [],
				units: {
					options: [],
					selectedUnits: [],
					allSelected: false
				},
				errors: [],
				loadingGif: ''
			}
		};
		
	},
	watch: {
		'view.parametersPanel.exportPlates.units.allSelected'(value) {
			if (value) {
				this.view.parametersPanel.exportPlates.units.selectedUnits = [];
			}
		}
	},
	computed: {
		isRestrictionRulesInteractable(){
			return !!this.view.restrictionRulesPanel.selectedRule;
		},
		restrictionRulesModalTitle(){
			const restrictionRulesTitles = {
				add: t('add_retry_constraint_rule'),
				edit: t('edit_retry_restriction_rule')
			}
			return restrictionRulesTitles[this.view.restrictionModalData.mode];
		},
		consumptionHistoryMonthsIntervalInfo(){
			const monthsToAdd = this.view.consumptionHistoryPanel.interval || 6;

			const filteredDate = this.filteredData.DTMESCARD

			const endDate = moment(filteredDate, 'DD/MM/YYYY').set({date: 1});
			const beginningDate = moment(endDate).subtract(monthsToAdd, 'months');

			const endDateStr = endDate.locale('pt').format('MMMM/YYYY');
			const beginningDateStr = beginningDate.locale('pt').format('MMMM/YYYY');

			return `meses - ${beginningDateStr} a ${endDateStr}`;
		},
	},
	created(){
		this.replicateModal = this.view.parametersPanel.replicateModal;
		PlatesController.init();
		eventModule.$on('updateBoData', this.reloadPanelFilteredGrids);
		eventModule.$on('updateBoData', this.syncFilteredData);
		const permissions = permissionManager.getPlatesViewPermissions();
		Object.keys(permissions).forEach(panelName => this.view[panelName].isVisible = permissions[panelName]);
		this.syncFilteredData();
		this.loadConsumptionHistoryInterval();
	},
	mounted() {
		document.title = `${this.view.title} - Cardápio Inteligente`;
		PlatesController.sharedObject.onConsumptionHistoryCheckedRowsChange = this.onConsumptionHistoryCheckedRowsChange;
		PlatesController.vueContext = this;
		this.getFiliaOper();
		this.getFiliaOperForExport();
	},
	beforeDestroy(){
		eventModule.$off('updateBoData', this.reloadPanelFilteredGrids);
		eventModule.$on('updateBoData', this.syncFilteredData);
	},
	methods: {
		toggleReplicationAllUnitsSelected: function(){
			this.replicateModal.units.allSelected = !this.replicateModal.units.allSelected;
		},
		getFiliaOperForExport: function() {
			RestrictionProvider.getFiliaOper().then((filiais) => {
				this.view.parametersPanel.exportPlates.units.options = filiais;
			});
		},

		getFiliaOper: function() {
			RestrictionProvider.getFiliaOper().then((filiais) => {
				this.replicateModal.units.options = filiais;
			});
		},
		
		closeReplicationModal: function() {
			PlatesController.closeReplicationModal(this.$modal, this.replicateModal);
		},

		openReplicationModal: function() {
			PlatesController.openReplicationModal(this.$modal, this.replicateModal);
		},

		findDishesByFilterInput: function(){
			PlatesController.findDishesByFilterInput(this.replicateModal);
		},

		applyReplicationData: function() {
			PlatesController.applyReplicationData(this.$modal, this.replicateModal);
		},

		cancelReplication: async function() {
    		this.$modal.hide("replicate-modal-fields", {});
		},

		confirmReplication: async function() {
			await PlatesController.confirmReplication(this.$modal, this.replicateModal);
		},

		confirmErrors: function() {
			PlatesController.confirmErrors(this.$modal, this.replicateModal);
		},

		getGeneratedExcellFromPython: () => PlatesController.getGeneratedExcellFromPython(),
		addNewPreparationMethodRow: () => PlatesController.addNewRowToGrid(PlatesController.prapartionMethodGridConfiguration),
		addNewCutTypeRow: () => PlatesController.addNewRowToGrid(PlatesController.cutTypeGridConfiguration),
		addNewConsumptionHistoryRow: () => PlatesController.addNewRowToGrid(PlatesController.consumptionHistoryGridConfiguration),
		addNewPlateTypeRestrictionRuleRow: () => PlatesController.addNewRowToGrid(PlatesController.restrictionRulesPlateTypeGridConfig),
		addNewIngredientRestrictionRuleRow: () => PlatesController.addNewRowToGrid(PlatesController.restrictionRulesIngredientGridConfig),
		addNewMainIngredientRow: function() {
			PlatesController.addNewRowToGrid(PlatesController.mainIngredientGridConfiguration, false, true, true);
		},
		addNewProteinTypeRow: function() {
			PlatesController.addNewRowToGrid(PlatesController.typeProteinGridConfiguration, false, true, true);
		},
		addNewCombinationRow: function(){
			this.$modal.show("combination-form-modal");
		},
		addNewAttractivenessRow: function(){
			this.$modal.show("Attractiveness-form-modal");
		},
		afterCombinationSaved: function() {
			PlatesController.reloadCombination();
		},
		afterAttractivenessSaved: function() {
			PlatesController.reloadAttractiveness();
		},
		addNewAttractivness: () => PlatesController.addNewAttractivinessRow(),
		deleteAttractivness: (panel) => PlatesController.deleteAttractiviness(panel),
		deletePreparationMethod: (panel) => PlatesController.deletePreparationMethod(panel),
		deleteCutType: (panel) => PlatesController.deleteCutType(panel),
		deleteMainIngredient: (panel) => PlatesController.deleteMainIngredient(panel),
		deleteTypeProtein: (panel) => PlatesController.deleteTypeProtein(panel),
		deleteCombination: (panel) => PlatesController.deleteCombination(panel),
		deleteConsumptionHistory: (panel) => PlatesController.deleteConsumptionHistory(panel),
		sync: (v, obj, propName) =>  obj[propName] = v,
		reloadPanelFilteredGrids: function(){
			!this.view.parametersPanel.collapsed && this.view.parametersPanel.isVisible && this.view.parametersPanel.gridConfiguration.reloadData();
			!this.view.combinationPanel.collapsed && this.view.combinationPanel.isVisible && this.view.combinationPanel.gridConfiguration.reloadData();
			!this.view.attractivenessPanel.collapsed && this.view.attractivenessPanel.isVisible && this.view.attractivenessPanel.gridConfiguration.reloadData();
			!this.view.consumptionHistoryPanel.collapsed && this.view.consumptionHistoryPanel.isVisible && this.view.consumptionHistoryPanel.gridConfiguration.reloadData();
			!this.view.restrictionRulesPanel.collapsed && this.view.restrictionRulesPanel.isVisible && this.reloadRestrictionRules();
			// TODO: add reload to restriction rule here
		},
		invertValue: function(object, key){
			object[key] = !object[key];
		},
		onConsumptionHistoryCheckedRowsChange(ev){
			const {consumptionHistoryPanel} = this.view;
			this.updateCheckedRows(consumptionHistoryPanel, ev);
			const selectedRows = consumptionHistoryPanel.gridConfiguration.advancedOptions.api.getSelectedRows();
			consumptionHistoryPanel.isRowDeletable = selectedRows.length && selectedRows[0].NRHISTCONSUMOPRATO;
		},
		updateCheckedRows: function(panel, value){
			if(panel.isAddingNewRow){
				let selectedRows = panel.gridConfiguration.advancedOptions.api.getSelectedRows(); 
				panel.hasCheckedRows = (selectedRows.length && (selectedRows.length > 1 || !selectedRows[0].__is_new_row)); 
			} else {
				panel.hasCheckedRows = value;
			}
		},
		updateIsAddingNewRow: function(panel, value){
			panel.isAddingNewRow = value;
			!value && panel.gridConfiguration.enableSelection && panel.gridConfiguration.enableSelection();
		},
		removeNewRow: function(panel){
			let rows = panel.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && (rows[0].__removed = true) && rows.shift();
			panel.gridConfiguration.setRowData(rows);
			panel.gridConfiguration.enableSelection();
			panel.isAddingNewRow = false;
			panel.hasCheckedRows = false;
		},
		openImportModal: function(){
			PlatesController.openImportModal(this.$modal);
		},
		onHistoryTypeChange: function(type) {
			this.view.consumptionHistoryPanel.historyType = type;
			PlatesController.changeConsumptionHistoryDataSource(type);
			this.view.consumptionHistoryPanel.gridConfiguration.reloadData();
		},
		handleFileUpload(event) {
	      const file = event.target.files[0];
	      if (!file) return;
	
	      const reader = new FileReader();
	      reader.onload = (e) => {
	        try {
	          const data = new Uint8Array(e.target.result);
	          const workbook = XLSX.read(data, { type: 'array' });
	
	          // Processar o conteúdo da planilha conforme necessário
	          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
	          const jsonData = XLSX.utils.sheet_to_json(worksheet);
	
	          // Converta a planilha para base64 de forma segura
	          const base64File = this.arrayBufferToBase64(e.target.result);
	
	          const processedFile = {
	            name: file.name,
	            type: file.type,
	            size: file.size,
	            b64File: base64File
	          };
	
	          // Armazenar o objeto processedFile em processedData
	          this.processedData = [processedFile];
	        } catch (error) {
	          console.error('Erro ao processar o arquivo:', error);
	        }
	      };
	      reader.readAsArrayBuffer(file);
	    },
	    arrayBufferToBase64(buffer) {
	      let binary = '';
	      const bytes = new Uint8Array(buffer);
	      const len = bytes.byteLength;
	      for (let i = 0; i < len; i++) {
	        binary += String.fromCharCode(bytes[i]);
	      }
	      return btoa(binary);
	    },
    	
		submitFile(tableName) {
			if (this.processedData.length === 0) {
				Util.showErrorNotification({ 
					title: t('select_a_file_to_import')
				});
				return;
			}

			const IMPORT_SHEET = t('confirm_import_sheet');
			const CLEAR_FIELDS = t('dialog_clear_fields');
			const CLEAR_FIELDS_CONFIRM = t('dialog_clear_fields_confirm');
			const CLEAR_FIELDS_DENY = t('dialog_clear_fields_deny');

			const shouldAskClearFields = tableName !== 'IMP_HISTCONSUMOPRATO';

			let row = {
				sheetImport: this.processedData
			};

			const doSubmit = (clearFields = 'N') => {
				row = {
					...row,
					clearFields
				};

				this.isLoadingSubmit = true;

				PlatesController.submitFile(row, tableName)
					.then(() => {
						Util.showSuccessNotification({ 
							title: t('successful_import')
						});
					})
					.catch(e => {
						if (
							(e.error === "sheetErrors" || e.error === "procedureErrors") &&
							e.dataset?.errors
						) {
							this.showMessageErrorFile(e.dataset.errors, e.error);
						} else {
							Util.showErrorNotification({ title: t(e.error) });
						}
					})
					.finally(() => {
						this.isLoadingSubmit = false;
						this.clearFileInput();
						this.reloadField(tableName);
						this.view.parametersPanel.gridConfiguration.reloadData();
					});
			};

			Util.showConfirmationDialog(this.$modal, {
				onModalClose: function (confirmed) {
					if (!confirmed) return;

					if (!shouldAskClearFields) {
						// IMP_HISTCONSUMOPRATO → segue direto
						doSubmit('N');
						return;
					}

					// Demais tabelas → pergunta se limpa campos
					Util.showConfirmationDialog(this.$modal, {
						onModalClose: function (confirmedClear) {
							doSubmit(confirmedClear ? 'S' : 'N');
						}.bind(this)
					}, CLEAR_FIELDS, CLEAR_FIELDS_CONFIRM, CLEAR_FIELDS_DENY);

				}.bind(this)
			}, IMPORT_SHEET);
		},

		reloadField(tableName){
			switch (tableName) {
				case 'IMP_PARAMPRATFILIAL':
					this.view.parametersPanel.gridConfiguration.reloadData();
					break;
				case 'IMP_HISTCONSUMOPRATO':
					this.view.consumptionHistoryPanel.gridConfiguration.reloadData();
					break;
				default:
					break;
			}
		},
		clearFileInput() {
			this.$refs.fileInput.value = '';
			this.processedData = [];
		},		
		buildMessageFile: function(data, errorType) {
			let message = [];
			data.forEach((error) => {
				let msg = error;
				let match = msg.match(/Linha: \d+ - (.+)/);
				msg = msg.replace('Linha', t('Linha'));
            if (match && match[1]) {
            	msg = msg.replace(match[1], t(match[1]));
            }
            message.push({descricao: msg});
			});
			return message;
		},
		showMessageErrorFile: function(data, errorType) {
		    const messages = this.buildMessageFile(data, errorType);
		    const titulo = t('erros_importacao_planilha');
		    this.$modal.show({
		        template: `
		            <div class="validity-form-root" style="margin: 0; padding: 25px; width: calc(100% - 50px);"> 
		                <h3 class="title"> {{ messagesTitle }} </h3>
		                <div style="height: 45dvh; overflow-y: auto; padding: 30px 0; width: 100%;">
		                    <span v-for="message in messages" style="display:block; margin: 10px;">{{message.descricao}}</span>
		                </div>
		                <div>
		                    <button class="button" style="margin: 15px auto; display: block; min-width: 200px;" @click="close"> OK </button>
		                </div>
		            </div>
		        `,
		        props: ['messages', 'messagesTitle'],
		        methods: {
		            close() {
						this.$emit('close');
		            }
		        }
		    }, { messages, messagesTitle: titulo }, {
					height: 'auto',
					width: '69%',
		    });
		},
		switchMode(mode) {
			this.view.parametersPanel.exportPlates.exportPlatesMode = mode;
		},

		pickViewToUse(fieldName){
			switch (fieldName) {
				case 'parametersPanel':
					return this.view.parametersPanel
				case 'consumptionHistoryPanel':
					return this.view.consumptionHistoryPanel
				default:
					return
			}
		},
		
		enterExportPlateMode(fieldName) {
			PlatesController.enterSelectPlateMode(this.pickViewToUse(fieldName));
		},

		openModalExportPlates(){
			PlatesController.enterExportPlateMode(this.view.parametersPanel, this.$modal);
		},

		openModalHistoryConsumption(){
			if(PlatesController.prepareDataHistoryConsumption(this.view.consumptionHistoryPanel)){
				this.showExportModal('UNITY', 'HISTORYCONSUMPTION');
			}
		},

		clearExportPlatesUnits() {
			this.view.parametersPanel.exportPlates.units.selectedUnits = [];
			this.view.parametersPanel.exportPlates.units.allSelected = false;
		},

		closeExportPlatesModal() {
			this.$modal.hide('export-plates-modal-fields');
		},

		cancelExportPlatesInModal() {
			this.closeExportPlatesModal();
			this.exitExportMode();
			this.clearExportPlatesUnits();
		},

		importParameters: function() {PlatesController.importParameters(this.$modal, this.view.parametersPanel.importModal);},
		
		enterExportMode: function() {
			PlatesController.enterExportMode(this.view.parametersPanel, this.$modal);
		},
		exitExportMode: function() {
			PlatesController.exitExportMode(this.view.parametersPanel);
		},
		exitExportModeHistory: function() {
			PlatesController.exitExportMode(this.view.consumptionHistoryPanel);
		},
		closeExportModal: function(){
			this.view.parametersPanel.isExportingPlates = false;
			this.$modal.hide('export-modal-fields');
		},
		cancelExportInModal: function(){
			this.closeExportModal();
			this.exitExportMode();
		},
		confirmExport: function() {
			PlatesController.handleExport(this.view.parametersPanel);
			if(this.view.parametersPanel.isExportingPlates){
				this.cancelExportPlatesInModal()
			}
		},
		onPlateParameterCollapsed: function(v){
			this.view.parametersPanel.collapsed = v;
			this.view.parametersPanel.exporting && PlatesController.exitExportMode(this.view.parametersPanel);
		},
		reloadRestrictionRules(){
			PlatesController.sharedObject.selectedRestrictionRule = null;
			PlatesController.getRestrictionRules().then((rules) => {
				this.view.restrictionRulesPanel.rules = rules;
				this.view.restrictionRulesPanel.selectedRule = rules[0] || null;
				this.onRestrictionRuleSelected(this.view.restrictionRulesPanel.selectedRule);
			});
		},
		onRestrictionRulesPanelCollapsed(isCollapsed){
			this.view.restrictionRulesPanel.collapsed = isCollapsed;
			if(!isCollapsed){
				this.reloadRestrictionRules();
			}
		},
		onRestrictionRuleSelected(selectedRule){
			selectedRule = selectedRule || {}
			PlatesController.sharedObject.selectedRestrictionRule = selectedRule.NRREGRARESTREPET;
			PlatesController.restrictionRulesPlateTypeGridConfig.reloadData();
			PlatesController.restrictionRulesIngredientGridConfig.reloadData();
		},
		showAddRestrictionRulePopUp(){
			this.view.restrictionModalData.mode = 'add';
			this.view.restrictionModalData.name = "";
			this.$modal.show('restrictionRuleModal');
		},
		showEditRestrictionRulePopUp(){
			const {NMREGRARESTREPET, NRREGRARESTREPET} = this.view.restrictionRulesPanel.selectedRule || {};
			if(NRREGRARESTREPET){
				this.view.restrictionModalData.mode = 'edit';
				this.view.restrictionModalData.name = NMREGRARESTREPET;
				this.$modal.show('restrictionRuleModal');
			}
		},
		saveRestrictionRule(){
			const {restrictionModalData, restrictionRulesPanel} = this.view;
			const hideModal = this.$modal.hide;
			PlatesController.saveRestrictionRule(restrictionModalData.name, restrictionRulesPanel.rules, restrictionModalData.mode).
			then(function(restrictionRules){
				restrictionRulesPanel.rules = restrictionRules;
				hideModal('restrictionRuleModal');
			});
		},
		removePlateTypeRestrictionRule(){
			PlatesController.removePlateTypeRestrictionRule();
		},
		removeIngredientRestrictionRule(){
			PlatesController.removeIngredientRestrictionRule();
		},
		removeRestrictionRule(){
			const selectedRule = this.view.restrictionRulesPanel.selectedRule || {};
			const vm = this;
			PlatesController.removeRestrictionRule(this.$modal, selectedRule, function(){
				vm.view.restrictionRulesPanel.rules = vm.view.restrictionRulesPanel.rules.filter(o => {
					return o.NRREGRARESTREPET !== selectedRule.NRREGRARESTREPET
				});
				vm.view.restrictionRulesPanel.selectedRule = null;
			});
		},
		saveConsumptionHistoryInterval(value) {
			const {consumptionHistoryPanel} = this.view
			consumptionHistoryPanel.isSavingInterval = true
			PlatesController.updateConsumptionHistoryInterval(
				value
			).then(() => {
				consumptionHistoryPanel.gridConfiguration.reloadData()
				consumptionHistoryPanel.interval = value
				consumptionHistoryPanel.isSavingInterval = false
			}).catch(() => {
				this.loadConsumptionHistoryInterval()
				consumptionHistoryPanel.isSavingInterval = false
			})
		},
		updateConsumptionHistoryInterval({target}){
			const value = Number(target.value);
			const isInterger = Number.isInteger(value);
			const isInMonthRange = value >= 1;
			
			if(isInterger && isInMonthRange){
				this.saveConsumptionHistoryInterval(value);
			} else {
				const consumptionHistoryintervalInput = target;
				consumptionHistoryintervalInput.reportValidity();
			}
		},
		loadConsumptionHistoryInterval(){
			PlatesProvider.getConsumptionHistoryInterval().then((interval) => {
				const {consumptionHistoryPanel} = this.view;
				consumptionHistoryPanel.interval = interval
			}).catch(() => {
				Util.showErrorNotification({ 
					title: t('unable_to_load_consumption_history_range')
				})
			})
		},
		syncFilteredData(){
			this.filteredData = Util.getFilterInSession();
		},
		exportToExcel: function(view){
			const name = view.name !== 'consumptionHistoryPanel' ? view.title : view.title + ' ' + this.consumptionHistoryMonthsIntervalInfo;
			ExcelBuilder.fromJson(
				Util.getVisibleDataFromGrid(view.gridConfiguration),
				Util.getGridColDefsToColDetails(view.gridConfiguration.columnDefs),
				name,
				Util.getExcelHeaderFromFilter(),
			);
		},
		exportToExcelRestriction: function(view) {
			PlatesProvider.getExportPlatesGroups().then((response) => {
				const columnDefs = [];
				view.plateType.gridConfiguration.columnDefs.forEach((data) => { columnDefs.push(data) });
				view.ingredient.gridConfiguration.columnDefs.forEach((data) => { columnDefs.push(data) });
				const name = view.selectedRule.NRREGRARESTREPET + ' ' + view.selectedRule.NMREGRARESTREPET;
				ExcelBuilder.fromJson(
					response,
					Util.getGridColDefsToColDetails(columnDefs),
					view.title + ' ' + name,
					Util.getExcelHeaderFromFilter(),
				);
			});
		},
		getData(combinationPanel) {
			const selectedRows = combinationPanel.gridConfiguration.advancedOptions.api.getSelectedRows();
			const itemList = [];
			selectedRows.forEach(row => {
				if (row && row.NRCOMBINACAOCARD !== undefined) {
					itemList.push(row.NRCOMBINACAOCARD);
				}
			});
			return itemList;
		},
		showExportModal(modalStyle, nameTable) {
			const exportModal = this.view.exportDataModal;
			exportModal._style = modalStyle;
			exportModal._tableExport = nameTable;
			exportModal._showAdd = true;
			exportModal._showLoad = true;

			if (nameTable === 'COMBINACAOCARD') {
				const { combinationPanel } = this.view;
				const itemList = this.getData(combinationPanel);

				if (itemList.length === 0) {
					Util.showErrorNotification({ title: t('please_select_an_item_to_export') });
					return;
				}

				exportModal._itemSelected = itemList;
			}
			this.$modal.show("export-form-modal");
			this.$forceUpdate();
		},
		saveExport: function(view) {
			this.view.exportDataModal._showLoad = false;
			this.view.exportDataModal._mode = view.exportData.mode;
			this.callProcedure(view);
		},
		callProcedure: function(view) {
			this.view.exportDataModal._showLoad = false;
			this.view.exportDataModal._mode = view.exportData.mode;
			const filiServ = this.getFiliServ(view.exportData);
			this.$forceUpdate();
			switch (this.view.exportDataModal._tableExport) {
				case "HISTORYCONSUMPTION":
					PlatesProvider.callProcedureExportHistoryConsumption(
						filiServ,
						this.view.exportDataModal._tableExport, 
						this.view.consumptionHistoryPanel.exportModal.exportFrom,
						view.exportData.mode
					).then((response) => {
						if(response.data.length > 0) {
							this.showMessageErrorPrato(response.data);
						} else {
							this.view.exportDataModal._showLoad = true;
							Util.showSuccessNotification({ title: t('successful_export')});
							this.$modal.hide('export-form-modal');
							this.exitExportModeHistory();
						}
					})
					break;
				case "COMBINACAOCARD":
					const itemList = (this.view.exportDataModal._tableExport == 'COMBINACAOCARD') ? this.view.exportDataModal._itemSelected : [1];		
					PlatesProvider.callProcedureExportCadOtimizador(
						filiServ, 
						this.view.exportDataModal._tableExport, 
						itemList, 
						view.exportData.mode, 
						{MODE: null, GROUPARR: null}
					).then((response) => {
						if(response.data.length > 0) {
							this.showMessageError(response.data);
						} else {
							this.view.exportDataModal._showLoad = true;
							Util.showSuccessNotification({ title: t('successful_export')});
							this.$modal.hide('export-form-modal');
						}
					})
					break;
				default:
					Util.showErrorNotification({ title: t('ERROR') });
					this.$modal.hide('export-form-modal');
					break;
			}
		},
		getFiliServ: function(data) {
			const filiServ = [];
			if(data.checkedService) {
				data.services.forEach((service) => { filiServ.push(service.CDLISTA) });
			} else {
				data.selectedService.forEach((service) => { filiServ.push(service.CDLISTA) });
			}
			return filiServ;
		},
		buildMessage:function(data) {
			let message = [];
			data.forEach((error) => {
				let msg = error.DSERRO;
				msg = msg.replace('_MSGSTA_CONSISTE_GRUPOPRATO', '');
				msg = msg.replace("_MSGEND_", "");
				msg = msg.split("$$");
				message.push({ CDFILIAL: msg[1], CDSERVFILI: msg[2], CDGRUPRAT: msg[3] });
			});
			return message;
		},
		showMessageErrorPrato:function(data) {
			this.view.exportDataModal._showLoad = true;
            this.$modal.show({
                template:`
                    <div class="validity-form-root" style="margin: 0; padding: 25px; width: calc(100% - 50px);"> 
                        <h3 class="title"> Erros na Exportação: Prato local não exportado para uma ou mais unidades </h3>
                        <div style="height: 45dvh; overflow: auto; padding: 30px 0; width: 100%;">
                            <span v-for="message in data" style="display:block; margin: 10px;"> Prato: {{message.CDPRATO}} - {{message.NMPRATO}} 
                        </div>
                        <div>
                            <button class="button" style="margin: 15px auto; display: block; min-width: 200px;" @click="close"> OK </button>
                        </div>
                    </div>
                `,
                props: ['data'],
                methods:{
                    close(){this.$emit('close');}
                }
            }, {data}, {
                height:'auto',
                width:'69%',
            });
		},
		showMessageError:function(data) {
			this.view.exportDataModal._showLoad = true;
            const messages = this.buildMessage(data);
            this.$modal.show({
                template:`
                    <div class="validity-form-root" style="margin: 0; padding: 25px; width: calc(100% - 50px);"> 
                        <h3 class="title"> Erros na Exportação: Grupos de Pratos não associados ao serviço destino </h3>
                        <div style="height: 45dvh; overflow: auto; padding: 30px 0; width: 100%;">
                            <span v-for="message in messages" style="display:block; margin: 10px;"> Unidade: {{message.CDFILIAL}} Serviço: {{message.CDSERVFILI}} 
                            Grupo de Prato: {{message.CDGRUPRAT}}</span>
                        </div>
                        <div>
                            <button class="button" style="margin: 15px auto; display: block; min-width: 200px;" @click="close"> OK </button>
                        </div>
                    </div>
                `,
                props: ['messages'],
                methods:{
                    close(){this.$emit('close');}
                }
            }, {messages}, {
                height:'auto',
                width:'69%',
            });
		},
		showBatchOptimizer: function(){
			if (process.env.LOGIN_ORGANIZATION_ID =="1011") {
				return true;
			}

			return false;
		}
		
	},
};

</script>

<style lang="less">
	.recipe-grid{
		height: 100%;
	}
	.select-350{
		.v-select ul{
			width: 350px;
			z-index: 6;
		}
	}

	.inputs-div {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		align-items: center;
	}
	
	.restrinctions-select-autocomplete .vs__selected-options {
		flex-wrap: wrap !important;
		max-height: auto !important;
	}

	.restrinctions-select-autocomplete .vs__dropdown-menu {
		height: clamp(9.6rem, 12dvh, 15rem) !important;
	}
	// .modal-select .vs__dropdown-menu {
	// 	height: clamp(9.6rem, 12dvh, 15rem) !important;
	// }

	.export-plate-modal-check-container {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 10px 20px;
		margin-top: 15px;
	}

	.mode-switch {
		margin-top: 10px;
		font-size: .9rem;
		border-radius: 5px;
		width: fit-content;
		color: #DC143D;
		border: 1px solid #DC143D;
		cursor: pointer;
		user-select: none;
		width: 100%;
		display: flex;
		.mode-switch-option{
			flex: 1;
			text-align: center;
			border-radius: 5px;
			padding: 7px;
			transition: .3s background-color;
			&:hover{
				background-color: #fcdee4;
			}

			&.active{
				background-color: #DC143D;
				color: white;
			}
		}
	}

		#collapsible-panel.collapsible-panel-fullscren{
			position: fixed;
			top: var(--default-header-space, 57px);
			left: var(--menu-width, 100px);
			right: 0;
			z-index: 2;
			background-color: white;
			height: calc(100vh - var(--default-header-space, 57px) - 21px);
			width: auto;
			box-sizing: border-box;
			padding: 20px 15px;
			border-radius: 0;
			padding-top: 0px;
		margin:0;

		#panel-header{

			.up-arrow, .down-arrow{
				display: none;
			}
		}

		#panel-content{
			.ag-grid-instance{
				height: calc(100vh - 126px);
				&.history-low-height-grid {
					height: calc(100vh - 158px);
				}
			}

			.bottom-content-grid{
				.ag-grid-instance{
					height: calc(100vh - 185px);
				}
			}

			
		}
	}
</style>

<style scoped lang="less">
.panel-info{
	display: inline;
	cursor: help;
	.info-icon{
		color: #dc143d;
		font-size: 1.2rem;
	}
}

.rep-param-filter-input {
	height: 1rem;
	height: 22px;
	margin: 0 10px;
	border-radius: 4px;
	border: rgb(63, 63, 63) 1.6px solid;
	flex: 1;
}

.red-info{
	color: #dc143d;
	font-size: 18px;
}

.replicate-parameters-filter{
	display: flex;
	align-items: center;
	height: 2.6rem;
}

.replicate-modal-option-input{
	width: 65%;
	display: inline-block;
}

.replicate-modal-option-label{
	margin-left: 3px;
	display: inline-block;
	width: 140px;
}

.replicate-modal-option {
	display: inline-flex;
	align-items: anchor-center;
	gap: 0.5rem;
}

.replicate-modal-fields-container{
	//height: 84%;
	//height: 34rem;
	display: grid;
	grid-template-columns: 1fr 1fr

}

.select-container {

	padding-inline: 1.6rem;

	display: flex;
	flex-direction: column;
	gap: .5rem;

	.inputs-div{
		display: flex;
		gap: 1rem;
		align-items: center;
	}

	.restrinctions-select-autocomplete{
		width: 80%;
	}

	.input-container {
		//margin: auto;
		display: flex;
		gap: .5rem;
		align-items: center;

		input, label {
			vertical-align: middle;
			display: inline-block;
			cursor: pointer;
		}
	}
}
.allCheck {
	position: relative;
	cursor: pointer;
	height: 20px;
	width: 20px;
	//background-color: transparent;
	border: none!important;
	//display: none;
}
        
.allCheck:before {
	content: "";
	display: block;
	position: absolute;
	width: 20px;
	height: 20px;
	top: 0;
	left: 0;
	background-color: white;
	border: 2px solid #dc143d;
	border-radius: 2px;
}

.allCheck:checked:before {
	content: "";
	display: block;
	position: absolute;
	margin: auto;
	width: 20px;
	height: 20px;
	top: 0;
	left: 0;
	background-color: #dc143d;
	border: 2px solid #dc143d;
	border-radius: 2px;
}

.allCheck:checked:after {
	content: "";
	display: block;
	width: 5px;
	height: 10px;
	border: solid white;
	border-width: 0 2px 2px 0;
	-webkit-transform: rotate(45deg);
	transform: rotate(45deg);
	position: absolute;
	top: 20%;
	left: 40%;
}

.errors-container {
  margin: 1rem 0;
  max-height: 60vh;
  overflow-y: auto;
}
.error-item {
  padding: 0.5rem;
  border-bottom: 1px solid #eee;
  font-size: 0.9rem;
}

.consumption-history-panel{
	&.is-saving-interval{
		pointer-events: none;
		opacity: .7;
	}
}

.consumption-history-interval-container {
  position: relative;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column; /* permite quebrar linha para o erro */

  .consumption-history-main-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap; /* evita quebrar layout em telas menores */
  }

  .error-message {
    display: none;
    font-size: 0.8rem;
    color: red;
    margin-top: 4px;
  }

  .consumption-history-interval-input {
    height: 22px;
    margin: 0 10px;
    border-radius: 4px;
    border: rgb(63, 63, 63) 1.6px solid;

    &:invalid {
      border: red 1.6px solid;

      ~ .error-message {
        display: block;
      }
    }
  }
}

/* Radios */
.consumption-history-type-container {
  display: flex;
  gap: 12px;
  margin-left: 16px;
}

.consumption-history-type-container label {
  display: flex;
  align-items: center;
  gap: 4px;
}


.restriction-rules-panel{

	
	.restriction-rule-select{
		width: 280px;
		font-size: 0.8rem;
		display: inline-block;
	}
	
	.bottom-section{
		display: inline-flex;
		width: 100%;
		margin-top: 10px;

		.plate-type-grid-container{
			flex: 1;
		}

		.ingredient-grid-container{
			flex: 2;
		}

		&.disabled{
			pointer-events: none;
			opacity: .2;
		}
	}
}


.restriction-rule-form-root{
	width: calc(100% - 30px);
	margin: 25px;
	margin-bottom: 30px;

	.title{
		margin-bottom: 5px;
		margin-left: 10px;
	}

	.field{
		display: inline-block;
		margin: 10px;
		text-align: left;
		font-size: .9rem;
		width: calc(100% - 45px);

		&.text-field{
			input{ 
				padding: 6px 0px 7px 8px;
			}
		}

		input{
			padding: 5px;
			border: 1px solid #BDBDBD;
			box-sizing: border-box;
			border-radius: 4px;
			width: 100%;

			&.input-label{
				border: none;
				border-bottom: 1px solid #BDBDBD;
				border-radius: 0;
			}
		}
	}
	
	.save-restriction-rule-button{
		.plate-grid-button;
		margin-left: 10px;
	}
}

#plates{
	height: 100vh;
	width: 100vw;
	// display: grid;
	// grid-template-columns: 11vw 89vw;
	display: flex;
}

.export-modal-container{
	margin: 15px;
	padding: 18px 20px;
	background: #ffffff;
	border: 1px solid #ececf3;
	border-radius: 12px;
	box-shadow: 0 10px 28px rgba(33, 33, 70, 0.12);

	h3{
		margin: 0 0 14px;
		color: #212146;
		font-size: 1.05rem;
		font-weight: 600;
	}

	.button + .button{
		margin-left: 10px;
	}
}

.export-modal-check-container{
	margin: 0 0 14px;
	padding: 8px;
	border: 1px solid #e6e8f3;
	border-radius: 10px;
	background: #f9fafe;
}

.export-modal-option, .replicate-modal-option{
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 8px 0px;
	padding: 7px 10px;
	color: #796d6d;
	cursor: pointer;
	transition: color .2s, background-color .2s;
	user-select: none;
	border-radius: 8px;

	&:hover{
		background-color: #eef1fb;
		color: #212146;
	}

	&.selected{
		color: #212146;
		background-color: #edf0ff;

		.export-modal-options-checkbox-container{
			.checkbox-unselected{
				opacity: 0;
			}

			.checkbox-selected{
				opacity: 1;
			}
		}
	}

	.export-modal-option-label{
		margin-left: 3px;
		font-weight: 500;
	}

	.export-modal-option-value{
		color: #5b5f7e;
	}

	.export-modal-options-checkbox-container{
		width: 20px;
		height: 10px;
		display: inline-block;
		position: relative;

		.checkbox-selected, .checkbox-unselected{
			position: absolute;
			transition: opacity .2s;
			width: 25px;
			height: 25px;
			left: -2px;
			top: -3px;
		}

		.checkbox-unselected{
			opacity: 1;
		}

		.checkbox-selected{
			opacity: 0;
		}
	}
}

.import-modal{
	margin: 12px;
	
	.import-modal-title{
		margin-block-start: 15px;
		margin-block-end: 10px;
	}

	.import-modal-grid{
		height: 259px;
	}
}

.screen-container{
	height: 100vh;
	overflow-y: scroll;
	flex: 1;
}

.plate-grid-button{
	font-size: .9rem;
	padding: 6px 13px;
	&.disabled{
		background-color: gray;
    	pointer-events: none;
	}
}

.button-container {
  display: flex;
  justify-content: space-between; /* Garante que os botões fiquem em lados opostos */
  align-items: center;
  width: 100%;
  flex-wrap: nowrap; /* Evita quebra de linha entre os contêineres */
}

.button-container-align-left, .button-container-align-right {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 5px; /* Espaçamento entre os botões e o input */
}

.button-container-align-left {
  justify-content: flex-start; /* Alinha os botões à esquerda */
}

.export-mode-buttons {
  display: flex;
  align-items: center;
  gap: 10px; /* espaço entre os botões */
}

.button-container-align-right {
  justify-content: flex-end;
}

.gray-button {
  .plate-grid-button;
		box-shadow: none;
		background-color: #dedede;
		color: #383838;
		&:hover{
			background-color: gray;
			color:white;
		}
}

input[type="file"] {
.plate-grid-button;
  cursor: pointer;
}

input[type="file"]::file-selector-button {
  .plate-grid-button;
  background-color: #dedede;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

input[type="file"]::file-selector-button:hover {
  background-color: gray;
  color: white;
}


		#screen-container{
			#header-component{
				position: relative;
				z-index: auto;
				width: 100%;
			}
			#panel-container{
				margin-top: 0;
			}

		.low-height-grid{
			height: 200px;
		}
	}

	.v--modal-overlay{
		z-index: 21;
	}

	.loading-overlay {
	    position: fixed;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background-color: rgba(0, 0, 0, 0.5);
	    z-index: 9999;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    color: white;
	    font-size: 18px;
	    text-align: center;
	}
	
	.loading-content {
	    display: flex;
	    align-items: center;
	}
	
	.spinner {
	    border: 4px solid rgba(255, 255, 255, 0.3);
	    border-radius: 50%;
	    border-top: 4px solid white;
	    width: 40px;
	    height: 40px;
	    animation: spin 1s linear infinite;
	    margin-right: 20px;
	}
	
	@keyframes spin {
	    0% { transform: rotate(0deg); }
	    100% { transform: rotate(360deg); }
	}

</style>
